module.exports = __webpack_public_path__ + "img/img-02.6b5d52ea.jpg";